<div class="flex flex-col items-stretch flex-1">
  <csl-angle-mode-select
    [angleProcessingAvailability]="angleProcessingAvailability"
    [dense]="dense"
    [editable]="!disabled"
    [(mode)]="angle.mode"
    (modeChange)="setSingleButt(); clearOtherModeValues(); setMasonsMitreParams(); anglesChange.next(outline)"
    [anglePosition]="anglePosition"
    [outline]="outline"
    [materialType]="materialType"
    class="flex flex-col items-stretch">
  </csl-angle-mode-select>

  <ng-container [ngSwitch]="angle.mode">
    <ng-container *ngSwitchCase="thisAngleMode.Cutted">
      <csl-cut-input
        [dense]="dense"
        *ngIf="angleProcessingAvailability.cutting"
        [(x)]="angle.cutX"
        [(y)]="angle.cutY"
        [editable]="!disabled"
        (xChange)="anglesChange.emit(outline)"
        (yChange)="anglesChange.emit(outline)"
        [xMax]="getMin(xMax, outlineOptions.angles.cutting.restrictions.max)"
        [yMax]="getMin(yMax, outlineOptions.angles.cutting.restrictions.max)"
        [xMin]="outlineOptions.angles.cutting.restrictions.min"
        [yMin]="outlineOptions.angles.cutting.restrictions.min"
        class="flex flex-col items-stretch">
      </csl-cut-input>
    </ng-container>

    <ng-container *ngSwitchCase="thisAngleMode.Rounded">
      <csl-rounding-input
        [dense]="dense"
        *ngIf="angleProcessingAvailability.rounding"
        [value]="angle.rounding"
        [editable]="!disabled"
        [max]="getMin(outlineOptions.angles.rounding.restrictions.max, max)"
        [min]="outlineOptions.angles.rounding.restrictions.min"
        (valueChange)="angle.rounding = $event; anglesChange.emit(outline)"
        class="flex flex-col items-stretch">
      </csl-rounding-input>
    </ng-container>

    <ng-container *ngSwitchCase="thisAngleMode.RoundedInside">
      <csl-rounding-input
        [dense]="dense"
        *ngIf="angleProcessingAvailability.insideRounding"
        [editable]="!disabled"
        [value]="angle.roundingInside"
        [max]="getMin(outlineOptions.angles.insideRounding.restrictions.max, max)"
        [min]="outlineOptions.angles.insideRounding.restrictions.min"
        (valueChange)="angle.roundingInside = $event; anglesChange.emit(outline)"
        class="flex flex-col items-stretch">
      </csl-rounding-input>
    </ng-container>

    <ng-container *ngSwitchCase="thisAngleMode.CuttedInside">
      <csl-inside-cut-input
        [dense]="dense"
        *ngIf="angleProcessingAvailability.insideCutting"
        [editable]="!disabled"
        [x]="angle.cutInsideX"
        [y]="angle.cutInsideY"
        [r]="angle.cutInsideR"
        (xChange)="angle.cutInsideX = $event; anglesChange.emit(outline)"
        (yChange)="angle.cutInsideY = $event; anglesChange.emit(outline)"
        (rChange)="angle.cutInsideR = $event; anglesChange.emit(outline)"
        [xMax]="getMin(xMax, outlineOptions.angles.insideCutting.restrictions.max)"
        [yMax]="getMin(yMax, outlineOptions.angles.insideCutting.restrictions.max)"
        [xMin]="getMax(outlineOptions.angles.insideCutting.restrictions.min, angle.cutInsideR)"
        [yMin]="getMax(outlineOptions.angles.insideCutting.restrictions.min, angle.cutInsideR)"
        [rMax]="getMin(outlineOptions.angles.insideCutting.restrictions.radiusMax, angle.cutInsideX, angle.cutInsideY)"
        [rMin]="outlineOptions.angles.insideCutting.restrictions.radiusMin"
        class="flex flex-col items-stretch">
      </csl-inside-cut-input>
    </ng-container>

    <ng-container *ngSwitchCase="thisAngleMode.CuttedInsideWithAngle">
      <csl-inside-cut-with-angle-input
        [dense]="dense"
        *ngIf="angleProcessingAvailability.insideCuttingWithAngle"
        class="flex flex-col"
        [editable]="!disabled"
        [x]="angle.cutInsideWithAngle.x"
        [y]="angle.cutInsideWithAngle.y"
        [xA]="angle.cutInsideWithAngle.xA"
        [yA]="angle.cutInsideWithAngle.yA"
        [r]="angle.cutInsideWithAngle.r"
        (xChange)="angle.cutInsideWithAngle.x = $event; anglesChange.emit(outline)"
        (yChange)="angle.cutInsideWithAngle.y = $event; anglesChange.emit(outline)"
        (xAChange)="angle.cutInsideWithAngle.xA = $event; anglesChange.emit(outline)"
        (yAChange)="angle.cutInsideWithAngle.yA = $event; anglesChange.emit(outline)"
        (x1Change)="angle.cutInsideWithAngle.x1 = $event; anglesChange.emit(outline)"
        (y1Change)="angle.cutInsideWithAngle.y1 = $event; anglesChange.emit(outline)"
        (rChange)="angle.cutInsideWithAngle.r = $event; anglesChange.emit(outline)"
        [xMax]="getMin(xMax, outlineOptions.angles.insideCuttingWithAngle.restrictions.max)"
        [yMax]="getMin(yMax, outlineOptions.angles.insideCuttingWithAngle.restrictions.max)"
        [xMin]="getMax(outlineOptions.angles.insideCuttingWithAngle.restrictions.min, angle.cutInsideWithAngle.r)"
        [yMin]="getMax(outlineOptions.angles.insideCuttingWithAngle.restrictions.min, angle.cutInsideWithAngle.r)"
        [rMax]="
          getMin(
            outlineOptions.angles.insideCuttingWithAngle.restrictions.radiusMax,
            angle.cutInsideWithAngle.x,
            angle.cutInsideWithAngle.y
          )
        "
        [rMin]="outlineOptions.angles.insideCuttingWithAngle.restrictions.radiusMin">
      </csl-inside-cut-with-angle-input>
    </ng-container>

    <ng-container *ngSwitchCase="thisAngleMode.Chamfer">
      <csl-chamfer-input
        [dense]="dense"
        *ngIf="angleProcessingAvailability.chamfer"
        [editable]="!disabled"
        [value]="angle.chamferLength"
        [max]="getMin(outlineOptions.angles.chamfer.restrictions.max, max)"
        [min]="outlineOptions.angles.chamfer.restrictions.min"
        (valueChange)="angle.chamferLength = $event; anglesChange.emit(outline)">
      </csl-chamfer-input>
    </ng-container>

    <ng-container *ngSwitchCase="thisAngleMode.MasonsMitreFemale">
      <csl-masons-mitre-input
        [dense]="dense"
        *ngIf="angleProcessingAvailability.masonsMitre"
        [value]="angle.masonsMitreFemale.length"
        [orientation]="angle.masonsMitreFemale.orientation"
        [editable]="!disabled"
        [max]="angle.masonsMitreFemale.orientation === thisMasonsMitreOrientationEnum.AlongHeight ? xMax : yMax"
        [min]="0"
        (valueChange)="angle.masonsMitreFemale.length = $event; anglesChange.emit(outline)"
        (orientationChange)="angle.masonsMitreFemale.orientation = $event; anglesChange.emit(outline)"
        class="flex flex-col items-stretch">
      </csl-masons-mitre-input>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <!-- <mat-form-field class="auto-width">
        <input matInput placeholder="" disabled value="0">
        <div i18n matSuffix>мм</div>
      </mat-form-field> -->
    </ng-container>
  </ng-container>

  <csl-butt-select
    [dense]="dense"
    *ngIf="!disableButt"
    [butts]="butts"
    [editable]="!disabled"
    [(selected)]="angle.butt"
    (selectedChange)="anglesChange.emit(outline)">
  </csl-butt-select>
</div>
